
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/tutorials/dynamically-change-widget-content",
      function () {
        return require("private-next-pages/help-centre/tutorials/dynamically-change-widget-content.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/tutorials/dynamically-change-widget-content"])
      });
    }
  